export enum WatchlistLoanStatusType {
    Uncured = 1,
    CuredButOutstanding = 2,
    Cured = 3,
}

export const WatchlistLoanStatusTypeOptions = [
    {
        id: WatchlistLoanStatusType.Uncured,
        name: 'Uncured',
    },
    {
        id: WatchlistLoanStatusType.CuredButOutstanding,
        name: 'Cured but Outstanding',
    },
    {
        id: WatchlistLoanStatusType.Cured,
        name: 'Cured',
    },
];
